<template>
  <div class="w-100 grid-container">
    <vt-side-panel :visible="showSidePanel">
      <!-- TODO: Enlazarlo correctamente para que muestre las pestañas: "Orígenes de incidencias" y "Tipos de entidades" -->
      <configuration-sidepanel-basic
        :sidepanel-title="sidepanelTitle"
        :icon="'far fa-sitemap'"
        :list="selectedOperations"
        @closeConfigurationSidepanelBasic="showSidePanel = false"
      />
    </vt-side-panel>
    <configuration-section-header
      class="my-0"
      :section-icon="'far fa-list-ul'"
      :section-title="$tc('configuration.sections.incidentTypes', 2)"
      @changedPageSize="changedPageSize($event)"
      @changedMode="changedMode($event)"
    >
      <b-button
        v-tooltip="$t('configuration.actions.activate')"
        :disabled="!canActivateBatch"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
        @click="activateDeactivateSelection(true, selectedRows)"
      >
        <i
          class="far fa-check-circle"
          aria-hidden="true"
        />
      </b-button>
      <b-button
        v-tooltip="$t('configuration.actions.deactivate')"
        :disabled="!canDeactivateBatch"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
        @click="activateDeactivateSelection(false, selectedRows)"
      >
        <i
          class="far fa-times-circle"
          aria-hidden="true"
        />
      </b-button>
      <div
        style="width:1px; height:18px; background: #d0d0d0"
        class="mx-3"
      />
      <b-button
        v-shortkey="['alt', 'del']"
        v-tooltip="$t('configuration.actions.delete')"
        :disabled="!selectedRows.length || checkOriginsSystemDefined"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
        @click="deleteMorphology(selectedRows)"
        @shortkey="deleteMorphology(selectedRows)"
      >
        <i
          class="far fa-trash-alt"
          aria-hidden="true"
        />
      </b-button>
      <b-button
        v-shortkey="['alt', 'e']"
        v-tooltip="$t('configuration.actions.update')"
        :disabled="!selectedRows.length || checkOriginsSystemDefined"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
        @click="showConfigurationIncidentTypesForm($t('configuration.actions.update'), selectedRows[0])"
        @shortkey="showConfigurationIncidentTypesForm($t('configuration.actions.update'), selectedRows[0])"
      >
        <i
          class="far fa-edit"
          aria-hidden="true"
        />
      </b-button>
      <b-button
        v-shortkey="['ctrl', 'enter']"
        v-tooltip="$t('configuration.actions.add')"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
        @click="showConfigurationIncidentTypesForm($t('configuration.actions.add'))"
        @shortkey="showConfigurationIncidentTypesForm($t('configuration.actions.add'))"
      >
        <i
          class="far fa-plus"
          aria-hidden="true"
        />
      </b-button>
    </configuration-section-header>
    <div class="flex-grow-1">
      <vt-grid
        class="configuration-grid"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :component-code="gridUiComponent"
      />
    </div>
    <modal-wrapper ref="configurationIncidentTypesModalWrapper">
      <configuration-incident-types-modal
        ref="configurationIncidentTypesModal"
        :action-title="actionTitle"
        @update="patchTypes($event)"
        @create="createType($event)"
      />
    </modal-wrapper>
  </div>
</template>

<script>
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader'
import VtGrid from '@/components/VtGrid/VtGrid'
import ColumnsIncidentTypesGridColumns from '@/modules/configurationModule/detail/incidents/incidentsTypes/ColumnsIncidentTypesGridColumns'
import ConfigurationIncidentTypesModal from '@/modules/configurationModule/detail/incidents/incidentsTypes/ConfigurationIncidentTypesModal'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import IncidentTypesConfigurationServices from '@/api/resources/configuration/incidents/types/IncidentTypesConfigurationServices'
import IncidentTypesConfigurationOriginsRelationshipServices from '@/api/resources/configuration/incidents/types/IncidentTypesConfigurationOriginsRelationshipServices'
import ConfigurationSidepanelBasic from '@/modules/configurationModule/detail/ConfigurationSidepanelBasic'
import { some } from 'lodash'

export default {
    name: 'IncidentTypesConfigurationGrid',
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        ConfigurationIncidentTypesModal,
        ConfigurationSidepanelBasic
    },
    data() {
        return {
            gridUiComponent: 'uicomponent.configuration.global.incidents.incidentsTypes',
            actionTitle: null,
            selectedRows: [],
            columnDefs: ColumnsIncidentTypesGridColumns(),
            showSidePanel: false,
            sidepanelTitle: null,
            clickedRow: null,
            selectedOperations: [],
            mode: {
                size: 25
            }
        }
    },
    computed: {
        rowHeight() {
            return this.mode?.size
        },
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                onRowClicked: this.onRowClicked,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged,
                paginationPageSize: 20,
                paginationAutoPageSize: false,
                getRowHeight: () => this.rowHeight
            }
        },
        hasActiveType() {
            return this.selectedRows.find(type => type.active)
        },
        hasDeactiveType() {
            return this.selectedRows.find(type => !type.active)
        },
        hasAllActivated() {
            return this.selectedRows.length === (this.selectedRows.filter(type => type.active).length)
        },
        hasAllDeactivated() {
            return this.selectedRows.length === (this.selectedRows.filter(type => !type.active).length)
        },
        canDeactivateBatch() {
            return this.selectedRows.length && this.hasActiveType && !this.hasAllDeactivated
        },
        canActivateBatch() {
            return this.hasDeactiveType && !this.hasAllActivated
        },
        checkOriginsSystemDefined() {
            // If there is one in the collection that has the field 'systemDefined' defined(true), it will not be allowed to delete or update
            return some(this.selectedRows, 'systemDefined')
        }
    },
    methods: {
        async activateDeactivateSelection(option, selectionBatch) {
            const typesToPatch = selectionBatch.filter(type => type.active !== option).map(type => {
                return {
                    active: option,
                    id: type.id
                }
            })
            if (typesToPatch.length) {
                this.updateLoading(true)
                const [err] = await this.toCall(IncidentTypesConfigurationServices.patchTypesBatch(typesToPatch))
                this.updateLoading(false)
                if (err) {
                    this.showErrorModalGlobalFromErrorResponse(err)
                    return
                }
                if (selectionBatch.length > 1) this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.updated', 2, { elements: selectionBatch.length }))
                else this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.updated', 1))
                this.reloadData()
            }
        },
        async patchTypes(type) {
            const originTypeRequest = this.mapTypesToRequest(type)
            this.updateLoading(true)
            const [err, data] = await this.toCall(IncidentTypesConfigurationServices.patchTypesBatch([originTypeRequest]))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err)
                return
            } else if (data.length) {
                this.handleErrors(data)
                return
            }
            this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.updated', 1))
            this.reloadData()
        },
        async createType(type) {
            const originTypeRequest = this.mapTypesToRequest(type)
            this.updateLoading(true)
            const [err, newIncidentType] = await this.toCall(IncidentTypesConfigurationServices.createType(originTypeRequest))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err)
                return
            }
            await this.$refs.configurationIncidentTypesModal.setNewIncidentType(newIncidentType)
            this.showToastSuccessGlobal(this.$t('configuration.toastMessages.created'))
            this.reloadData()
        },
        async deleteTypesBatch(types) {
            const typesToDelete = types.map(type => type.id)
            this.updateLoading(true)
            const [err, response] = await this.toCall(IncidentTypesConfigurationServices.deleteTypesBatch(typesToDelete))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err)
                return
            } else if (response.length) {
                this.handleErrors(response)
                return
            }
            if (typesToDelete.length > 1) this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.deleted', 2, { elements: typesToDelete.length }))
            else this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.deleted', 1))
            this.reloadData()
        },
        reloadData() {
            this.gridApi.deselectAll()
            this.gridApi.setServerSideDatasource(new PaginatorDatasource(IncidentTypesConfigurationServices))
        },
        getContextMenuItems(params) {
            if (!params?.node) {
                return []
            } else {
                return [
                    {
                        name: this.$t('configuration.actions.update'),
                        cssClasses: this.selectedRows.length > 1 || params?.node.data.systemDefined ? ['not-show'] : '',
                        action: () => {
                            // Hide sidebar panel
                            this.showSidePanel = false
                            this.showConfigurationIncidentTypesForm(this.$t('configuration.actions.update'), params?.node.data)
                        }
                    },
                    {
                        name: this.$t('configuration.actions.delete'),
                        cssClasses: this.selectedRows.length < 1 || this.checkOriginsSystemDefined ? ['not-show'] : '',
                        action: () => {
                            // Hide sidebar panel
                            this.showSidePanel = false
                            this.deleteMorphology(this.selectedRows)
                        }
                    },
                    {
                        name: params?.node.data.active ? this.$t('configuration.actions.deactivate') : this.$t('configuration.actions.activate'),
                        cssClasses: this.selectedRows.length ? ['not-show'] : '',
                        action: () => this.activateDeactivateSelection(!params.node?.data.active, [params?.node.data])
                    },
                    {
                        name: this.$t('configuration.actions.activate'),
                        cssClasses: this.canActivateBatch ? '' : ['not-show'],
                        action: () => this.activateDeactivateSelection(true, this.selectedRows)
                    },
                    {
                        name: this.$t('configuration.actions.deactivate'),
                        cssClasses: this.canDeactivateBatch ? '' : ['not-show'],
                        action: () => this.activateDeactivateSelection(false, this.selectedRows)
                    }
                ]
            }
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        onGridReady({ api }) {
            this.gridApi = api
            api.setServerSideDatasource(new PaginatorDatasource(IncidentTypesConfigurationServices))
        },
        showConfigurationIncidentTypesForm(title, type) {
            this.actionTitle = title
            this.$refs.configurationIncidentTypesModalWrapper.show([type])
        },
        async deleteMorphology(types) {
            if (types.length) {
                const promise = await this.showConfirmationModalGlobal(`${this.$t('configuration.grid.deleteConfirmation')} ${this.selectedRows.length} ${this.$tc('configuration.grid.element', this.selectedRows.length)}, <br/> ${this.$t('configuration.grid.deleteQuestion')}`, this.$t('configuration.actions.delete'))
                if (promise) {
                    await this.deleteTypesBatch(types)
                }
            }
        },
        async onRowClicked(params) {
            await this.getAssociations(params?.node.data.id)
            this.showSidePanel = true
            this.clickedRow = params?.node.data
            this.sidepanelTitle = params?.node.data.name
        },
        async getAssociations(id) {
            const response = await this.$_toCallUnique(IncidentTypesConfigurationOriginsRelationshipServices.getIncidentTypeOriginsRelationship(id))
            if (!response) {
                return
            }
            this.selectedOperations = [{
                key: 'relationshipOrigin',
                translatedName: 'configuration.sections.originsRelationship',
                data: response.map((relation) => {
                    return { name: relation.incidentOrigin && relation.incidentOrigin.name }
                })
            },
            {
                key: 'relationshipEntity',
                translatedName: 'configuration.sections.entitiesRelationship',
                data: [...(new Set(response.map(relation => relation.coreEntity.translatedName)))]
                    .map(name => { return { name } })
            }
            ]
        },
        mapTypesToRequest(type) {
            return {
                active: type.active,
                id: type.id,
                descriptionTranslations: type.descriptionTranslations.map(description => ({ languageId: description.language.id, notes: description.notes, value: description.value })),
                nameTranslations: type.nameTranslations.map(description => ({ languageId: description.language.id, notes: description.notes, value: description.value }))
            }
        },
        changedPageSize(pageSize) {
            this.gridApi.paginationSetPageSize(pageSize)
        },
        changedMode(selectedOption) {
            this.mode = selectedOption
            this.reloadData()
        }
    }
}
</script>
